import styled from 'styled-components';

import { FloatingLabelTextArea } from 'components/floating-label-fields';

export const InstructionsTextarea = styled.textarea`
  width: 100%;
  font-family: ${Styles.fontFamily.body};
  font-size: 0.9375rem;
  resize: vertical;
  border: 1px solid ${Styles.color.grey.four};
  border-radius: ${Styles.borderRadius};
  padding: 1rem 2rem 1rem 1rem;
  margin: 0.65rem 0 1.25rem;

  :focus {
    outline: none;
    border-color: ${Styles.color.primary};
  }
`;

export const StyledFloatingLabelTextArea = styled(FloatingLabelTextArea)`
  & > textarea {
    line-height: 1.5;
    padding: 1rem 2rem 1rem 1rem;
    min-height: auto;
  }
`;
